module.exports = __webpack_public_path__ + "img/banner3.0ef9767e.svg";